import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { DELETE_GROUP_VERSION_OGMP_CATEGORY_MUTATION } from "../../../../graphql/mutations";

const DeleteVersionCategoryModal = ({ show, groupVersionId, category, handleClose, handleEnvChange, env, tenantName, currentTenant }) => {
  const navigate = useNavigate();
  const [deleteVersionCategory, { loading: mutationLoading }] = useMutation(DELETE_GROUP_VERSION_OGMP_CATEGORY_MUTATION);

  const handleDeleteGroupVersion = async () => {
    try {
      const { data } = await deleteVersionCategory({
        variables: {
          ogmpCategoryId: category.id,
          groupVersionId
        }
      });

      if (data?.deleteGroupVersionOGMPCategory) {
        handleClose();
        setTimeout(() => {
          toast.success("Version OGMP Category deleted successfully.");
          navigate("/version-categories");
          handleEnvChange(env, currentTenant, tenantName, groupVersionId);
        }, 200);
      }
    } catch (error) {
      handleClose();
      setTimeout(() => {
        toast.error("Failed to delete version ogmp category.");
        console.error("Delete error:", error);
      }, 200);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="d-flex justify-content-center">
        <Modal.Title className="w-100 text-center">Delete Version OGMP Category</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-center">
          Are you sure you want to delete the version ogmp category for category: <strong>{category.name}</strong>?
        </p>
        <p className="text-center text-danger"> This will un-assign this category from the current group version.</p>
        <div className="d-flex justify-content-center mt-4">
          <Button variant="primary" onClick={handleClose} className="me-2">
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteGroupVersion} disabled={mutationLoading}>
            {mutationLoading ? "Deleting..." : "Delete"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export { DeleteVersionCategoryModal };
